import { makeNullSafeDomainGetter, madadAgentBannerSelector } from './common';
import { createSelector } from 'reselect';

const madadAgentBannerDataSelector = makeNullSafeDomainGetter(madadAgentBannerSelector, 'getMadadAgentBanner');
export const madadAgentBannerItemSelector = createSelector(madadAgentBannerDataSelector, (b) => b || { desktop: null, mobile: null, officeName: null });

